// extracted by mini-css-extract-plugin
export var messageSideLeft = "_p2-1";
export var stateContainer = "_p2-0";